import React, { Component } from "react";
import Popup from "../Popup/Popup";
import Strings from "@my-dld/assets/strings";
import { VIPRequest } from "@eres/vipownerapi/entities";
import { I8N } from "@eres/core";

interface Props {
	request: VIPRequest;
	onDismiss: () => void;
}

interface State {

}

class ManagerDetails extends Component<Props, State> {
	render() {
		const { request, onDismiss } = this.props;
		const mobile = request.Mobile;
		const email = request.Email;
		return <Popup
			id={ "ManagerDetails" } title={ Strings.account_manager_details } showIcon={ false }
			onDismiss={ onDismiss }>
			<div className="side-panel">
				<ul className="list-group sidepanel-account-manager">
					<li className="list-group-item disabled hide"/>
					<li className="list-group-item">
						<small>{ Strings.name }</small><br/>
						{ I8N.isRTL() ? request.ManagerNameAr : request.ManagerNameEn }
					</li>
					<li className="list-group-item">
						<small>{ Strings.personal }</small><br/>
						<a href={ `tel:${ mobile }` }>{ mobile }</a>
					</li>
					<li className="list-group-item">
						<small>{ Strings.email }</small><br/>
						<a href={ `mailto:${ email }` }>{ email }</a>
					</li>
				</ul>
			</div>
		</Popup>;
	}
}

export default ManagerDetails;
